export function DemoBanner() {
  return (
    <div className="demo-banner" role="status">
      <strong>Development demonstration data</strong>
      <span>
        Values on this page are synthetic until the H100 collector sends observed telemetry. Production
        mode refuses to start with this banner enabled.
      </span>
    </div>
  )
}
